import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { APP_LANGUAGES, LANGUAGES_CODES, URL } from "../constants";
import { MessageService } from "./message.service";
import { BehaviorSubject } from "rxjs";
import { SessionService } from "./session.service";
import en from "@angular/common/locales/en";
import { de_DE, en_US, NzI18nService } from "ng-zorro-antd/i18n";


@Injectable()
export class I18nService {
	currentLanguage: BehaviorSubject<string> = new BehaviorSubject<string>(
		APP_LANGUAGES.GERMAN
	);

	constructor(
		private translateService: TranslateService,
		private messagesService: MessageService,
		private sessionService: SessionService,
		private i18n: NzI18nService
	) {
		this.translateService.onLangChange.subscribe((response) => {
			if (response) {
				this.currentLanguage.next(response.lang);
				if(response.lang==='de') {
					this.i18n.setLocale(de_DE);
				}
				else{
					this.i18n.setLocale(en_US);
				}
			}
		});
	}

	getNormalizedString(storagedLanguage: string) {
		return storagedLanguage.slice(0, 2);
	}

	/**
	 *    Switch to specified language by setting it to locale.
	 * @param language : language sting
	 */
	switchLanguage(language: string): void {
		if (language === LANGUAGES_CODES.ENGLISH) {
			this.translateService.use("en");
			this.sessionService.language = LANGUAGES_CODES.ENGLISH;
			this.currentLanguage.next(
				this.getNormalizedString(LANGUAGES_CODES.ENGLISH)
			);
		} else if (language === LANGUAGES_CODES.DEBUG) {
			this.translateService.use("cheat");
			this.sessionService.language = LANGUAGES_CODES.DEBUG;
			this.currentLanguage.next(
				this.getNormalizedString(LANGUAGES_CODES.DEBUG)
			);
		} else {
			this.translateService.use("de");
			this.sessionService.language = LANGUAGES_CODES.GERMAN;
			this.currentLanguage.next(
				this.getNormalizedString(LANGUAGES_CODES.GERMAN)
			);
		}
		this.messagesService.sendMessage({ languageChange: language });
		return;
	}

	/**
	 * Get privacy policy and terms of service urls
	 */
	getPrivacyPolicyAndTermsAndConditionsUrl(): object {
		const language = localStorage.getItem("language");
		const urls: object = {};
		if (language === LANGUAGES_CODES.ENGLISH) {
			urls["termsAndConditions"] = URL.ENGLISH.TAC;
			urls["privacyPolicy"] = URL.ENGLISH.PRIVACY_POLICY;
			return urls;
		}
		urls["termsAndConditions"] = URL.GERMAN.TAC;
		urls["privacyPolicy"] = URL.GERMAN.PRIVACY_POLICY;
		return urls;
	}
}
